var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExternalUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "21.9,21.9 2.1,21.9 2.1,2.1 9.6,2.1 9.6,4.1 4.1,4.1 4.1,19.9 19.9,19.9 19.9,14.4 21.9,14.4  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "21.9,2 21.9,11.1 19.9,11.1 19.9,5.4 12.7,12.4 11.3,11 18.4,4 12.8,4 12.8,2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalUrl);
export default __webpack_public_path__ + "static/media/icon-external-url.ac5c00b20bba408443bc0b97029b2b96.svg";
export { ForwardRef as ReactComponent };